import Image from "react-bootstrap/Image";
import dummyImage from "assets/img/anonymous_user.svg";

import styles from "./style.module.scss";

const VLAvatar = (props: VLAvatarProps) => {
  const { size, userAvatar } = props;

  return (
    <Image
      className={styles[size]}
      src={userAvatar || dummyImage}
      roundedCircle
      alt="avatar-img"
      referrerPolicy="no-referrer"
    />
  );
};

interface VLAvatarProps {
  userAvatar?: string;
  size: "xxsmall" | "xsmall" | "small" | "medium" | "large";
}

export default VLAvatar;
